import funds from '@/api/funds'

export default () => ({
  namespaced: true,

  state: {
    map: {}
  },

  actions: {
    fetch (context, isin) {
      return funds.fetch(isin)
        .then(data => context.commit('fetch', {isin, data}))
    }
  },

  mutations: {
    fetch (state, { isin, data }) {
      state.map = {
        ...state.map,
        [isin]: data
      }
    }
  },

  getters: {
    getByISIN: ({map}) => (isin) => {
      return map[isin]
    }
  }
})
